import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FinancialAsset } from '@app/models/project.models';
import { FinancialAssetRequest } from '@app/models/financial-assets.models';
import { v4 as uuidv4 } from 'uuid';

/** Not-completed loan = FinancialAsset with type/connection from basedata (e.g. Loan + NotPerformingLoan). */
export interface NotCompletedLoanFormGroup {
  id: FormControl<string>;
  type: FormControl<number>;
  projectConnectionType: FormControl<number>;
  name: FormControl<string | null>;
  interestRate: FormControl<number | null>;
  applicableReturn: FormControl<number | null>;
  start: FormControl<Date | null>;
  end: FormControl<Date | null>;
  payFrequency: FormControl<number | null>;
}

const DEFAULT_TYPE = 0; // Loan
const DEFAULT_PROJECT_CONNECTION_TYPE = 3; // NotPerformingLoan

export function getNotCompletedLoanFormGroup(
  fb: FormBuilder,
  type: number = DEFAULT_TYPE,
  projectConnectionType: number = DEFAULT_PROJECT_CONNECTION_TYPE
): FormGroup<NotCompletedLoanFormGroup> {
  return fb.nonNullable.group({
    id: fb.nonNullable.control<string>(uuidv4()),
    type: fb.nonNullable.control<number>(type),
    projectConnectionType: fb.nonNullable.control<number>(projectConnectionType),
    name: fb.control<string | null>(null),
    interestRate: fb.control<number | null>(null),
    applicableReturn: fb.control<number | null>(null),
    start: fb.control<Date | null>(null),
    end: fb.control<Date | null>(null),
    payFrequency: fb.control<number | null>(null),
  });
}

export function getFinancialAssetRequestFromNotCompletedLoanForm(
  form: FormGroup<NotCompletedLoanFormGroup>,
  projectId: string
): FinancialAssetRequest {
  const v = form.getRawValue();
  return {
    projectId,
    type: v.type,
    projectConnectionType: v.projectConnectionType,
    name: v.name ?? '',
    interestRate: v.interestRate ?? 0,
    applicableReturn: v.applicableReturn ?? 0,
    start: v.start ?? new Date(),
    end: v.end ?? new Date(),
    payFrequency: v.payFrequency ?? 0,
  };
}

export function getNotCompletedLoanFormGroupFromFinancialAsset(
  fb: FormBuilder,
  asset: FinancialAsset
): FormGroup<NotCompletedLoanFormGroup> {
  const group = getNotCompletedLoanFormGroup(
    fb,
    asset.type,
    asset.projectConnectionType
  );
  group.controls.id.setValue(asset.id, { emitEvent: false });
  group.patchValue({
    name: asset.name,
    interestRate: asset.interestRate,
    applicableReturn: asset.applicableReturn,
    start: asset.start,
    end: asset.end,
    payFrequency: asset.payFrequency,
  });
  return group;
}
